import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { Accordion, Typography } from 'ck-ui';
import classnames from 'classnames';
import styles from './Faq.module.scss';

const Faq = ({ blockFaq }) => {
  const isMobile = useMedia('(max-width: 767px)');

  return (
    <section className={classnames('container', { [styles.root]: isMobile })}>
      <Typography variant={isMobile ? 'heading4' : 'heading2'} className={styles.header}>{blockFaq.title} </Typography>
      {blockFaq.faqSection.map((section) => (
        <section key={section._key}>
          <Typography variant={isMobile ? 'heading5' : 'heading3'} uppercase className={styles.mg}>{section.header}</Typography>
          {section.qa.map((item) => <Accordion key={item._key} title={item.question} content={item.answer} />)}
        </section>
      ))}
    </section>
  );
};

Faq.propTypes = {
  blockFaq: PropTypes.object.isRequired
};

export { Faq };
